import { render, staticRenderFns } from "./emailExclude.vue?vue&type=template&id=7edf032a&scoped=true"
import script from "./emailExclude.vue?vue&type=script&lang=js"
export * from "./emailExclude.vue?vue&type=script&lang=js"
import style0 from "./emailExclude.vue?vue&type=style&index=0&id=7edf032a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edf032a",
  null
  
)

export default component.exports